import html2canvas from 'html2canvas';
import {jsPDF} from 'jspdf';

export const exportToPDF = async (resumeRef) => {
  try {
    // const element = resumeRef.current.children[0];
    // 似乎导出整个paper更好看点
    const element = resumeRef.current;
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: false,
      allowTaint: true,
      backgroundColor: null,
      onclone: (clonedDoc) => {
        // 在克隆的文档中修改所有 ul 元素的样式
        const uls = clonedDoc.getElementsByTagName('ul');
        for (const ul of uls) {
          ul.style.listStylePosition = 'outside';
          ul.style.listStyleType = 'disc';
        
          // 确保 li 元素也有正确的样式
          const lis = ul.getElementsByTagName('li');
          for (const li of lis) {
            li.style.display = 'list-item';
            li.style.listStyleType = 'disc';
            li.style.marginLeft = '-10px';
          }
        }
      }
    });

    // A4 尺寸（单位：pt）
    const pageWidth = 595;
    const pageHeight = 842;
    
    // 计算实际内容高度
    const contentWidth = canvas.width;
    const contentHeight = canvas.height;
    
    // 计算缩放比例
    const scale = pageWidth / contentWidth;
    const scaledHeight = contentHeight * scale;
    
    // 计算需要的页数
    const pageCount = Math.ceil(scaledHeight / pageHeight);
    
    // 创建PDF文档
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'pt',
      format: 'a4'
    });

    // 分页处理
    for (let i = 0; i < pageCount; i++) {
      if (i > 0) {
        pdf.addPage();
      }

      // 计算当前页需要显示的内容
      const sourceY = (pageHeight / scale) * i;
      const sourceHeight = Math.min(pageHeight / scale, contentHeight - sourceY);
      
      // 创建临时canvas用于当前页
      const tempCanvas = document.createElement('canvas');
      tempCanvas.width = canvas.width;
      tempCanvas.height = sourceHeight;
      
      const ctx = tempCanvas.getContext('2d');
      ctx.drawImage(
        canvas,
        0,
        sourceY,
        canvas.width,
        sourceHeight,
        0,
        0,
        canvas.width,
        sourceHeight
      );

      const imgData = tempCanvas.toDataURL('image/jpeg', 1.0);
        // 保存图片到本地
        // const link = document.createElement('a');
        // link.href = imgData;
        // link.download = `resume_page_${i + 1}.jpg`;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      pdf.addImage(
        imgData,
        'JPEG',
        0,
        0,
        pageWidth,
        (sourceHeight * scale)
      );
    }

    pdf.save('resume.pdf');
  } catch (error) {
    console.error('导出PDF失败:', error);
    throw error;
  }
}; 